import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
 
import { PcTabsPage } from '../pages/pc-tabs/pc-tabs';
import { PartesService } from '../services/partes.services';

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule, /*AngularFireDatabase*/ } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AuthProvider } from '../providers/auth/auth';
import { HideKeyboardModule } from 'hide-keyboard';

import { Geolocation } from '@ionic-native/geolocation';
import { FichadaDetallePage} from '../pages/fichada-detalle/fichada-detalle';
import { FichadaEditPage} from '../pages/fichada-edit/fichada-edit';

export const firebaseConfig = {
  apiKey: "AIzaSyBr_TnbStKYkXnMFqkkfstkd1xxqeTXlbM",
  authDomain: "pcrecol.firebaseapp.com",
  databaseURL: "https://pcrecol.firebaseio.com",
  storageBucket: "pcrecol.appspot.com",
  messagingSenderId: '138534963741'
};

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    PcTabsPage,
    FichadaDetallePage,
    FichadaEditPage,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {tabsHideOnSubPages: true,}),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    HideKeyboardModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    PcTabsPage,
    FichadaDetallePage,
    FichadaEditPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    PartesService,
    Geolocation,
    AuthProvider,
    
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts